import type { PayloadAction } from "@reduxjs/toolkit"

/**
 * Creates a reusable reducer for updating a specific property in a slice.
 * Supports deep merging for nested objects.
 */
function generateSetPropReducer<State extends Record<string, any>>() {
  return <K extends keyof State>(
    state: State,
    action: PayloadAction<{ key: K; value: State[K]; replace?: boolean }>
  ) => {
    const { key, value, replace } = action.payload

    if (
      !replace &&
      value &&
      typeof value === "object" &&
      !Array.isArray(value)
    ) {
      state[key] = {
        ...(state[key] as Record<string, unknown>),
        ...value
      } as State[K]
    } else {
      state[key] = value
    }
  }
}

export { generateSetPropReducer }
